import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from '../../api/axios';
import { isNumeric } from "../../helpers/utils";
import styles from './Admin.module.css';
import LoadingModal from "../LoadingModal";
import { Link } from "react-router-dom";


const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditTextQuestion = () => {

	const navigate = useNavigate();

	let { questionId } = useParams();

	const [text, setText] = useState("");
	const [status, setStatus] = useState("active");
	const [maxLength, setMaxLength] = useState(50);
	const [feature, setFeature] = useState(true);
	const [priority, setPriority] = useState(1);


	const [textCopy, setTextCopy] = useState("");
	const [statusCopy, setStatusCopy] = useState("active");
	const [maxLengthCopy, setMaxLengthCopy] = useState(50);
	const [featureCopy, setFeatureCopy] = useState(true);
	const [priorityCopy, setPriorityCopy] = useState(1);

	const [canSave, setCanSave] = useState(false);

	const [isSaving, setIsSaving] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(questionId ? false : true);

	const parseResponse = (response) => {
		if (response && response.data) {

			console.log(JSON.stringify(response.data));

			setText(response.data.text);
			setStatus(response.data.status);
			setMaxLength(response.data.maxLength);
			setFeature(response.data.feature);
			setPriority(response.data.priority);

			setTextCopy(response.data.text);
			setStatusCopy(response.data.status);
			setMaxLengthCopy(response.data.maxLength);
			setFeatureCopy(response.data.feature);
			setPriorityCopy(response.data.priority);

			setIsSaving(false);
			setDataLoaded(true);
		} else {
			console.log("Error: response is not valid");
		}

	}

	const saveChanges = () => {
		if (questionId === undefined) {
			saveNewQuestion();
		} else {
			saveUpdatedQuestion();
		}
	}
	const saveNewQuestion = async () => {
		if (!canSave) {
			return;
		}

		const json = {};

		json.text = text;
		json.status = status;
		json.maxLength = maxLength;
		json.feature = feature;
		json.priority = priority;

		setIsSaving(true);
		try {
			const response = await axios.post(`/textQuestions`,
				JSON.stringify(json),
				{
					headers: { 'Content-Type': 'application/json' }
				}
			);
			console.log(response.data);
			questionId = response.data.questionId;

			parseResponse(response);

			navigate(`/textquestion/edit/${questionId}`, { replace: true });

		} catch (err) {
			console.log(err);
			// if (!err?.response) {
			//     setErrMsg('No Server Response');
			// } else if (err.response?.status === 409) {
			//     setErrMsg('Email Taken');
			// } else {
			//     setErrMsg('Registration Failed')
			// }
			// errRef.current.focus();
		}

	}

	const saveUpdatedQuestion = async () => {
		if (!canSave) {
			return;
		}

		const json = {};

		json.text = text;
		json.status = status;
		json.maxLength = maxLength;
		json.feature = feature;
		json.priority = priority;

		setIsSaving(true);
		try {
			const response = await axios.put(`/textQuestions/${questionId}`,
				JSON.stringify(json),
				{
					headers: { 'Content-Type': 'application/json' }
				}
			);

			parseResponse(response);

		} catch (err) {
			console.log(err);
			// if (!err?.response) {
			//     setErrMsg('No Server Response');
			// } else if (err.response?.status === 409) {
			//     setErrMsg('Email Taken');
			// } else {
			//     setErrMsg('Registration Failed')
			// }
			// errRef.current.focus();
		}

	}

	useEffect(() => {

		if (questionId === undefined) {
			return;
		}

		let isMounted = true;

		const controller = new AbortController();

		const getTextQuestion = async () => {

			setIsSaving(true);

			try {
				const response = await axios.get(`/textQuestions/${questionId}`, {
					signal: controller.signal
				});
				console.log(response.data);
				if (isMounted) {
					parseResponse(response);
				}
			} catch (err) {
				if (isMounted) {
					console.error(err);
					// if (err.response?.status === 403) {
					//     navigate('/login', { state: { from: location }, replace: true });
					// }
				}
			}
		}

		getTextQuestion();

		return () => {
			isMounted = false;
			controller.abort();
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		let
			valid = true;

		if (!validTextRegex.test(text)) {
			valid = false;
		}
		if (!isNumeric(maxLength)) {
			valid = false;
		}

		const changed =
			(text !== textCopy) ||
			(status !== statusCopy) ||
			(feature !== featureCopy) ||
			(priority !== priorityCopy) ||
			(maxLength !== maxLengthCopy);

		setCanSave(valid && changed);

	}, [text, status, maxLength, feature, priority, textCopy, statusCopy, maxLengthCopy, featureCopy, priorityCopy]);

	if (!dataLoaded) {
		return <LoadingModal />;
	}

	console.log(`EditTextQuestion: render at ${new Date().getTime()}`);

	return (
		<section className={styles.admin}>
			<p><Link to="/admin">Admin</Link> &gt; <Link to="/questions">Questions</Link></p>
			<h3 className={styles.noBorder}>{(questionId === undefined) ? "New text" : "Text"} question</h3>

			<input type="text" name="question" autoComplete="off" autoFocus={true} maxLength="500" placeholder="Who is your favorite Red Sox player?" value={text} onChange={e => setText(e.target.value)} />

			<h3>Status:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="active" name="status" value="active" onChange={(e) => setStatus(e.target.value)} checked={status === "active"} />
				<label htmlFor="active">Active</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="archived" name="status" value="archived" onChange={(e) => setStatus(e.target.value)} checked={status === "archived"} />
				<label htmlFor="archived">Archived</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="deleted" name="status" value="deleted" onChange={(e) => setStatus(e.target.value)} checked={status === "deleted"} />
				<label htmlFor="deleted">Deleted</label>
			</div>

			<label htmlFor="maxLength">Maximum length:</label>
			<input
				type="number"
				id="maxLength"
				name="maxLength"
				required
				min="0"
				max="999"
				inputMode="decimal"
				pattern="\d*"
				autoComplete="off"
				value={maxLength}
				onChange={(e) => setMaxLength(e.target.value)}
			/>

			{/* <label htmlFor="priority">Priority (5: highest, 1: lowest)</label>
            <select name="priority" value={priority} onChange={(e) => setPriority(parseInt(e.target.value, 10))}>
                <option value="5">5 (Highest)</option>
                <option value="4">4 (High)</option>
                <option value="3">3 (Moderate)</option>
                <option value="2">2 (Low)</option>
                <option value="1">1 (Lowest)</option>
            </select> */}

			{/* <div className="checkbox-and-label" style={{ marginTop: '1rem' }}>
                <input type="checkbox" id="feature" name="feature" onChange={(e) => setFeature(e.target.checked)} checked={feature} />
                <label htmlFor="feature">Feature this question on a dashboard</label>
            </div> */}

			<button disabled={!canSave || isSaving} onClick={saveChanges}>Save changes</button>

		</section>
	);

};

export default EditTextQuestion;